import React, { useEffect } from 'react';
import useApi from '../../hook/useApi';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';

const AirdropCardLayer = () => {
     const { AsyncGetApiCall } = useApi();
     const [airdropStats, setAirdropStats] = useState(null);
     const [loading, setLoading] = useState(false);

     const getAirdropStats = async () => {
          try {
               setLoading(true)
               const result = await AsyncGetApiCall("/airdrop/stats");
               if (result?.success) {
                    setAirdropStats(result?.data);
               }
               else {
                    toast.error(result?.errors?.[0]);
               }
               console.log("result : ", result);
          } catch (error) {
               console.log("error : ", error);
          } finally {
               setLoading(false)
          }
     }

     useEffect(() => {
          getAirdropStats();
     }, []);

     return (
          <>
               {loading && <Loader />}
               <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px', paddingLeft: '0', paddingRight: '0', }}>

                    <div className='airdrop-card'>
                         <h6 className="text-xl">Whitelisted Wallets</h6>
                         <span className='fw-semibold text-lg'>{airdropStats?.uniqueAddress}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Unique Addresses</h6>
                         <span className="fw-semibold text-lg">{airdropStats?.uniqueAddress}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Claimed Tokens</h6>
                         <span className="fw-semibold text-lg">{airdropStats?.claimedTokens}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Distributed Tokens</h6>
                         <span className="fw-semibold text-lg">{airdropStats?.distributedTokens}</span>
                    </div>
               </div>
          </>
     );
};

export default AirdropCardLayer;